import { Grid, Paper, Typography } from "@mui/material"
import { Title } from "components/Common/Title"
import { TrainingChart } from "components/TrainingReportList/TrainingChart"
import { TrainingReportList } from "components/TrainingReportList/TrainingReportList"
import { useAppDispatch, useAppSelector } from "hooks"
import { useEffect } from "react"
import lessonService from "services/lessonService"
import organizationService from "services/organizationService"
import trainingReportService from "services/trainingReportService"
import userService from "services/userService"
import { setLessons } from "slices/lessonSlice"
import { setCurrentOrganization } from "slices/organizationSlice"
import { setTrainingReports } from "slices/trainingReportSlice"
import { setCurrentUser, setSelectedUser } from "slices/usersSlice"
import { UserRoles } from "types/userRoles"

export function Training() {
  const dispatch = useAppDispatch()

  const lessons = useAppSelector((state) => state.lesson.lessons)
  const trainingReports = useAppSelector((state) => state.trainingreport.trainingReports)

  const currentUser = useAppSelector((state) => state.users.currentUser)
  const selectedUser = useAppSelector((state) => state.users.selectedUser)

  useEffect(() => {
    if (currentUser === undefined || selectedUser !== currentUser) {
      userService
        .getBearerUser()
        .then((user) => {
          dispatch(setCurrentUser(user))
          dispatch(setSelectedUser(user))

          if (user.role === UserRoles.ORGANIZATION_ADMIN || user.role === UserRoles.HIAB_ADMIN) {
            organizationService
              .getOrganization(user.organizationId)
              .then((organization) => {
                dispatch(setCurrentOrganization(organization))
              })
              .catch((err) => {
                console.log(err)
              })
          }

          trainingReportService
            .getUserTrainingReports(user.id)
            .then((reports) => {
              dispatch(setTrainingReports(reports))
            })
            .catch((err) => {
              console.log(err)
            })
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (lessons.length < 1) {
      lessonService
        .getLessons()
        .then((lessons) => {
          dispatch(setLessons(lessons))
        })
        .catch((err) => {
          console.log(err)
        })
    }

    if (currentUser !== undefined && trainingReports.length < 1) {
      trainingReportService
        .getUserTrainingReports(currentUser.id)
        .then((reports) => {
          dispatch(setTrainingReports(reports))
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [currentUser, dispatch, lessons.length, selectedUser, trainingReports.length])

  return (
    <Grid container spacing={3}>
      <Grid item xs={3}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column", height: 250 }}>
          <Grid>
            <Grid item>
              <Title>COMPLETED LESSONS</Title>
            </Grid>
            <Grid container justifyContent="center">
              <Typography variant="h1">{trainingReports.length}</Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={9}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            height: 250,
          }}
        >
          <Title>TRAINING ACTIVITY</Title>
          <Grid item xs={12}>
            <TrainingChart trainingReports={trainingReports} />
          </Grid>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Title>TRAINING HISTORY</Title>
          <Grid item xs={12}>
            <TrainingReportList trainingReports={trainingReports} />
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}
